import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    getChatbotResponse: ["inputText"],
    // getChatbotInitialState: null,
    getChatbotResponseLoading: null,
    getChatbotResponseSuccess: ["res"],
    setChatbotResponseSuccess: null,
    getChatbotResponseFailure: ["error"],
    openChatbot: ["openChatbot"],
    setChatbotToGlobalView: ["showChatbotGlobally"],
    setChatbotForPageView: ["isInternalVarAvailable", "showParticularPage"],
    showHideChatbot: ["bCheckfieldToShowChatbot"],
  },
  { prefix: "CHATBOT_" }
);

export const ChatbotTypes = Types;

export default Creators;
